import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`Groups`}</strong>{` aggregate events based on entities, such as organizations or companies. They are especially useful for B2B customers and enable you to deploy feature flags, analyze insights, and run experiments at a group-level, as opposed to a user-level.`}</p>
    <p>{`To clarify what we mean, let's look at a few examples:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`For B2B SaaS apps, you can create a `}<strong parentName="p">{`company`}</strong>{` group type. This enables you to aggregate events at a company-level, and calculate metrics such as `}<inlineCode parentName="p">{`number of daily active companies`}</inlineCode>{`, `}<inlineCode parentName="p">{`company churn rate`}</inlineCode>{`, or `}<inlineCode parentName="p">{`how many companies have adopted a new feature`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`For a communication app like Slack, you can create a `}<strong parentName="p">{`channel`}</strong>{` group type. This enables you to measure metrics like `}<inlineCode parentName="p">{`average number of messages per channel`}</inlineCode>{`, `}<inlineCode parentName="p">{`number of monthly active channels`}</inlineCode>{`, or `}<inlineCode parentName="p">{`total number of channel participants`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`For collaborative, project-based apps like Notion, Jira, or Figma, you can create a `}<strong parentName="p">{`project`}</strong>{` group type. This enables you to calculate metrics like `}<inlineCode parentName="p">{`project pageviews`}</inlineCode>{`, `}<inlineCode parentName="p">{`users per project`}</inlineCode>{`, and `}<inlineCode parentName="p">{`project engagement`}</inlineCode>{`.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      